export default __webpack_public_path__ + "static/media/expired-bg.e2586a64.png";